import { isReverificationCancelledError } from "@clerk/react/errors";
import { toast } from "sonner";

/** Clerk API errors carry the readable reason in errors[0]. */
export function clerkErrorMessage(error: unknown, fallback: string) {
  const first = (error as { errors?: { long_message?: string; message?: string }[] })
    ?.errors?.[0];
  return first?.long_message || first?.message || fallback;
}

/**
 * Toast a failed Clerk call. Silent when the user closed Clerk's
 * reverification prompt (useReverification) — that is a cancel, not an error.
 */
export function toastClerkError(error: unknown, fallback: string) {
  if (isReverificationCancelledError(error)) return;
  toast.error(clerkErrorMessage(error, fallback));
}
